import { isObject } from '../is-object';
/**
 *  Internal { type: 'JSExpression', source: '', value: '', extType: 'function' } is equivalent to JSFunction
 */
export function isInnerJsFunction(data) {
  if (!isObject(data)) {
    return false;
  }
  return data.type === 'JSExpression' && data.extType === 'function';
}
export function isJSFunction(data) {
  if (!isObject(data)) {
    return false;
  }
  return data.type === 'JSFunction' || isInnerJsFunction(data);
}